import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../../../utils copy/@reduxjs/toolkit';
import { DashboardInterface, DashboardState } from '../types';
import moment from 'moment';
export const initialState: DashboardState = {
  loading: false,
  pageSize: 10,
  totalRow: 0,
  search: '',
  pageNo: 1,
  DashboardWallet: 0,
  DashboardFormData: {
    booking: 0,
    totalPrice: 0
  },
  DashboardSearchList: {},
  DashboardGraphDataList: [],
  DashboardList: {
    booking: 0,
    totalPrice: 0
  },
  DashboardTotalList: [],
  editIndex: 0,
  isadd: false,
  dissableCheck: false,
  startDate: moment(new Date()).format("MM/DD/yyyy"),
  endDate: moment(new Date()).format("MM/DD/yyyy")
};

export const useClinicSlice = createSlice({
  name: 'DashboardState',
  initialState,
  reducers: {

    updateDateFilterFormValue: (state, action: PayloadAction<any>) => {
      state.startDate = action.payload;
    },
    updateCancelDateFilterFormValue: (state, action: PayloadAction<any>) => {
      state.endDate = action.payload;
    },
    doGetDashboardList: (state) => {},
    doGetWallet: (state) => {},
    doGetDashboardGraphData: (state, action: PayloadAction<any>) => {},
    setDashboardsList: (state, action: PayloadAction<DashboardInterface>) => {
      state.DashboardList = action.payload;
    },
    setGraphData: (state, action: PayloadAction<DashboardInterface>) => {
      // state.DashboardGraphDataList = action.payload;
      state.DashboardGraphDataList = action.payload;
    },
    setWalletData: (state, action: PayloadAction<DashboardInterface>) => {
      // state.DashboardGraphDataList = action.payload;
      state.DashboardWallet = action.payload;
    },
    setSearchData: (state, action: PayloadAction<DashboardInterface>) => {
      // state.DashboardGraphDataList = action.payload;
      state.DashboardSearchList = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      console.log('Loading');
      state.loading = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      console.log('pageNo');
      state.totalRow = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      console.log('pageNo');
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      console.log('pageSize');
      state.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    doGetDashboardTotalList: (state) => {},
    setAdminDashboardDataList: (state, action: PayloadAction<Array<any>>) => {
      state.DashboardTotalList = action.payload;
    }
  }
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
